// extracted by mini-css-extract-plugin
export var numberInputContainer = "_7o-0";
export var startPickingButton = "_7o-1";